import React, { useEffect } from "react";
import { ITkPrefecturesSelectProps } from "../../../type/componentsType/TkPrefecturesSelect";
import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import { Prefectures } from "../../../assets/data/Constants";
import "./_style.scss";

/**
 * 都道府県専用プルダウン部品
 * 都道府県を選択するためのプルダウン
 * @param {"small" | "medium"} size プルダウンのサイズ
 * @param {any} onChange 値が変更された場合のイベント
 * @param {any} wantToSetValue デフォルト値
 * @param {boolean} error エラー
 * @see TkLocationGroup 住所入力フォーム部品
 * @return TkPrefecturesSelect 都道府県専用プルダウン部品
 */
export const TkPrefecturesSelect: React.FC<ITkPrefecturesSelectProps> = (
  props
) => {
  const { onChange, size = "small", wantToSetValue, error, ...rest } = props;
  const [relValue, setRelValue] = React.useState("");
  const [prefectures, setPrefectures] = React.useState<any>([{}]);

  useEffect(() => {
    const enumArray = Object.entries(Prefectures).map(([key, value]) => ({
      key,
      value,
    }));

    setPrefectures([...enumArray]);
  }, []);

  useEffect(() => {
    setRelValue(wantToSetValue || "");
    onChange &&
      onChange({
        target: {
          value: wantToSetValue,
          selectItem: {
            value: wantToSetValue,
            key: prefectures?.find((item: any) => item.key === wantToSetValue)
              ?.value,
          },
        },
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantToSetValue]);

  /**
   * プルダウンの選択肢が変更されたときに呼び出される関数
   * @param event - イベントオブジェクト
   * @param event.target.value - 選択された値
   * @returns {void}
   */
  const handleChange = (event: any): void => {
    setRelValue(event.target.value);

    onChange &&
      onChange({
        target: {
          value: event.target.value,
          selectItem: {
            value: event.target.value,
            key: prefectures?.find(
              (item: any) => item.key === event.target.value
            )?.value,
          },
        },
      });
  };

  return (
    <FormControl error={error}>
      <Select
        className="tkPrefecturesSelect"
        onChange={handleChange}
        size={size}
        {...rest}
        value={relValue}
        inputProps={{ "data-testid": "tkSelectFromForTestInput" }}
      >
        <MenuItem className="noValueItem" value="" key={""}></MenuItem>
        {prefectures?.map((item: any, index: number) => {
          return (
            <MenuItem key={index} value={item.key}>
              {item.key}
            </MenuItem>
          );
        })}
      </Select>
      {error && <FormHelperText>選択してください</FormHelperText>}
    </FormControl>
  );
};

export default TkPrefecturesSelect;
